import { useState } from 'react';
import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[800px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-8">
          常见问题
        </h2>
        <div className="flex flex-col gap-3">
          {faqData.map((item, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              >
                <h3 className="font-heading text-base text-foreground-900 pr-4">
                  {item.question}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-200 ${
                      openIndex === i ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-4 md:px-5 pb-4 md:pb-5 -mt-1">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}